<!--
 @description 服务监控-应用详情页-应用状态tab
 @author xiehan
 @date 2018/11/07
-->
<template>
  <div>
    <div v-text="$t('common.noData')" v-if="appList.length === 0" style="text-align: center;"></div>
    <ul v-else>
      <li v-for="(item, index) in appList" class="status-info" :key="item.appName + index" @click="toPerformance(item)">
        <div class="status-describe status-describe-onlinebg" :class="{'status-describe-offlinebg' : item.status == 2}">
            <div class="status-name" v-text="item.appName"></div>
            <div class="status-host">
                <span v-text="item.ip"></span> :
                <span v-text="item.port"></span>
            </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import ServerMonitorBiz from '@/logic/intelligentMonitor/serverMonitorBiz'
  export default {
    data () {
      return {
        prevApp: '',
        appList: []
      }
    },
    props: ['app', 'group', 'active'],
    methods: {
      toPerformance (item) {
        this.$router.push({
          name: 'serverDetailPerformance',
          query: {
            group: item.group,
            app: item.appName,
            ip: `${item.ip}_${item.port}`,
            siteCode: this.$route.query.siteCode
          }
        })
      }
    },
    watch: {
      active () {
        if (this.active === 'status' && this.prevApp !== this.app) {
          ServerMonitorBiz.getAppInfo({
            group: this.group,
            appName: this.app,
            siteCode: this.$route.query.siteCode
          }).then((d) => {
            this.appList = d
            this.prevApp = this.app
          })
        }
      }
    },
    mounted () {
    }
  }
</script>

<style scoped>
  .status-info {
    width: 290px;
    height: 97px;
    color: white;
    display: inline-block;
    margin: 0 20px 20px 0;
    cursor: pointer;
  }
  .status-describe {
    height: 100%;
    width: 100%;
    position: relative;
    border-radius: 2px;
  }
  .status-name {
    width: 100%;
    font-size: 25px;
    padding: 14px 0px 0 18px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .status-host {
    width: 100%;
    padding: 10px 0px 0 18px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .no-data {
    text-align: center;
    margin-bottom: 20px;
  }
  .status-describe-onlinebg {
    background: #52B947;
  }
  .status-describe-offlinebg {
    background: #cccccc;
  }
</style>